import Vue from 'vue';

export default {
    SET_ARTICLEBODY: (state, { articleId, _articlebody }) => {
        Vue.set(state.articlebody, articleId, _articlebody || false);
        /* false means articleId not found */
    },
    // SET_RELATIVE: (state, { articleId,_relative }) => {
    //   Vue.set(state.relative, articleId, _relative || false) /* false means articleId not found */
    // },
    // SET_COMMENTS: (state, { articleId,_comments }) => {
    //   Vue.set(state.comments, articleId, _comments || false) /* false means articleId not found */
    // },
    SET_RELATIVE: (state, { articleId, _relative }) => {
        Vue.set(state.relative, articleId, _relative || false);
    },
    SET_COMMENTS: (state, { articleId, _comments }) => {
        Vue.set(state.comments, articleId, _comments || false);
    },
    SET_ODDSCHANGE: (state, { _oddsChange }) => {
        console.log('_oddsChange', _oddsChange);
        Vue.set(state, 'oddsChange', _oddsChange.teamData || false);
    },
};



// WEBPACK FOOTER //
// ./src/store/mutations.js